import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ClientFileInfoModel } from '@core/services/client/client.model';

export enum ClientFileActionTypes{   
    UPDATE_CLIENTFILE="[Client] Update Client File",
    UPDATE_CLIENTFILE_SUCCESS="[Client] Update Client File Success",
    UPDATE_CLIENTFILE_FAIL="[Client] Update Client File Fail"    
}

  
  export class UPDATECLIENTFILE implements Action{
    readonly type=ClientFileActionTypes.UPDATE_CLIENTFILE;
    constructor(public payload:ClientFileInfoModel) {}
 }

 export class UPDATECLIENTFILESUCCESS implements Action{
     readonly type=ClientFileActionTypes.UPDATE_CLIENTFILE_SUCCESS;
     constructor(public payload:Update<ClientFileInfoModel>) {}
  }

  export class UPDATECLIENTFILEFAIL implements Action{
     readonly type=ClientFileActionTypes.UPDATE_CLIENTFILE_FAIL;
     constructor(public payload:string) {}
  }
  


  export type ClientFileAction=
  | UPDATECLIENTFILE 
  | UPDATECLIENTFILESUCCESS
  | UPDATECLIENTFILEFAIL 
